import { t } from '@/lib/i18n/messages.js';
import { cn } from '@/lib/utils.js';

interface SharedViewBadgeProps {
  className?: string;
}

export function SharedViewBadge({ className }: SharedViewBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium',
        'bg-[var(--color-qup-border-dark)]/40 text-[var(--color-qup-text-muted-dark)]',
        className,
      )}
    >
      {t('saved_views.scope_shared')}
    </span>
  );
}
